import { useEffect } from 'react';
import { useMapController } from '../map/MapShell.js';
import { useThemeStore } from '../../app/themeStore.js';
import { useTrailStore } from './trailStore.js';

/** Renders the live breadcrumb trail behind own-ship on the map (spec 02). */
export function TrailLayer(): null {
  const controller = useMapController();
  const mode = useTrailStore((s) => s.mode);
  const points = useTrailStore((s) => s.points);
  const theme = useThemeStore((s) => s.theme); // re-tint on day/night

  useEffect(() => {
    if (!controller) return;
    if (mode === 'off') {
      controller.clearTrail();
      return;
    }
    controller.drawTrail(points.map((p) => [p.lat, p.lon] as [number, number]));
    return () => controller.clearTrail();
  }, [controller, mode, points, theme]);

  return null;
}
